import React from "react";
import ScrollElement from "./scroll-element";
import TextAnimation from "./scroll-text";

const MissionVision = () => {
	return (
		<section className="bg-gray-100 py-12">
			<div className="container mx-auto px-4">
				<h2 className="text-4xl text-theme font-bold text-center mb-8" style={{textShadow: "1px 1px 1px rgba(0, 0, 0, 0.5)"}}>
					Our Mission & Values
				</h2>
				<div className="flex flex-col md:flex-row items-center py-6 gap-8 overflow-hidden">
					{/* Mission Section */}
					<ScrollElement
						direction="left"
						viewport={{ amount: 0.5, margin: "0px 0px 0px 0px" }}
						className="flex-1 bg-white p-6 h-full shadow-lg rounded-lg"
					>
							<h3 className="text-2xl text-theme font-semibold mb-4">
								Our Mission
							</h3>
							<p className="text-gray-700 text-justify leading-relaxed">
								<TextAnimation text="The school is committed to provide education that fosters each individual in achieving the highest standards of the physical, the intellectual and the moral aspects of life. Our mission is to offer comprehensive programme to generate the student to learn, with the abilities to become personally fulfilled and socially responsible citizens." />
							</p>
					</ScrollElement>
					{/* Vision Section */}
					<ScrollElement
						direction="right"
						viewport={{ amount: 0.5, margin: "0px 0px 0px 0px" }}
						className="flex-1 bg-white p-6 h-full shadow-lg rounded-lg w-full"
					>
							<h3 className="text-2xl text-theme font-semibold mb-4">
								Our Values
							</h3>
							<p className="text-gray-700 flex flex-col leading-relaxed">
								<TextAnimation text="• Academic excellence" />
								<TextAnimation text="• Creativity and Innovation" />
								<TextAnimation text="• Character development" />
								<TextAnimation text="• Diversity and inclusion" />
							</p>
					</ScrollElement>
				</div>
			</div>
		</section>
	);
};

export default MissionVision;
